import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { IProductTreeItem } from '../models/productTreeItem'

export const getJbpProductsTreeCrud = () =>
  CrudStore.get(CrudStoreItemPartner360.JBPProductsTree) as Crud<IProductTreeItem>
